import script from "./EmployeeBankDetailsUser.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeeBankDetailsUser.vue?vue&type=script&setup=true&lang=js"

import "./EmployeeBankDetailsUser.vue?vue&type=style&index=0&id=3b6e1f3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b6e1f3e"]])

export default __exports__